import { render } from "./ForceChangePasswordModal.vue?vue&type=template&id=5486d736"
import script from "./ForceChangePasswordModal.vue?vue&type=script&lang=js"
export * from "./ForceChangePasswordModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__